// 2026-10-13：问答向平台和分店启用的后台管理账号开放，独立于平台超级管理员权限。
const positiveId = (value: unknown): boolean => {
  if (typeof value !== 'number' && typeof value !== 'string') return false
  const text = String(value).trim(), number = Number(value)
  return /^\d+$/.test(text) && Number.isSafeInteger(number) && number > 0
}

// 2026-10-18：启用管理员还须具备独立VIP问答权限，平台超管保持原特权，分店角色1不豁免。
export const canAskGptQuestions = (token: unknown, user: any, functions?: Record<string, any>): boolean =>
  typeof token === 'string' && !!token.trim() && !!user
  && positiveId(user.id) && positiveId(user.orgId) && positiveId(user.roleId)
  && Number(user.disable) !== 1
  && (!('roleStatus' in user) || ((typeof user.roleStatus === 'number' || typeof user.roleStatus === 'string')
    && Number(user.roleStatus) === 1))
  && ((Number(user.orgId) === 1000 && Number(user.roleId) === 1)
    || Boolean(functions?.['system.aiQuestions'] && Number(functions['system.aiQuestions'].disabled || 0) === 0))
